import { useState } from 'react';
import { DonVi, DonViCoSo, KhachHang, TaiKhoan } from '@/types/schemas';

/**
 * Hook for managing search field selections in the search dialog
 * @returns Search field states and setters
 */
export const useSearchFieldState = () => {
  const [selectedTaiKhoanNo, setSelectedTaiKhoanNo] = useState<TaiKhoan | null>(null);
  const [selectedKhachHang, setSelectedKhachHang] = useState<KhachHang | null>(null);
  const [selectedTaiKhoanCo, setSelectedTaiKhoanCo] = useState<TaiKhoan | null>(null);
  const [selectedDonVi, setSelectedDonVi] = useState<DonViCoSo | null>(null);

  const resetSearchFields = () => {
    setSelectedTaiKhoanNo(null);
    setSelectedKhachHang(null);
    setSelectedTaiKhoanCo(null);
    setSelectedDonVi(null);
  };

  return {
    selectedTaiKhoanNo,
    selectedKhachHang,
    selectedTaiKhoanCo,
    selectedDonVi,

    setSelectedTaiKhoanNo,
    setSelectedKhachHang,
    setSelectedTaiKhoanCo,
    setSelectedDonVi,

    resetSearchFields
  };
};
